import { Component } from '@angular/core';
import { Usuario } from './models/usuario';
import { FDLMService } from './services/FDLM.Service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  usuario: Usuario;

  constructor(private fdlmService: FDLMService,
    private router: Router  )
  {
  }


}




